import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import colors from '../../styles/colors';

export interface Props {
  columnCount: number;
}

export default class VirtualTr extends React.PureComponent<Props> {
  public render() {
    const { columnCount } = this.props;
    return (
      <StyledTr>
        <td colSpan={columnCount} />
      </StyledTr>
    );
  }
}

const StyledTr = styled.tr`
  td {
    box-sizing: content-box;
    outline: 3px solid white;
    background: ${colors.grey10};
    border-bottom: 1px solid ${colors.grey10};
  }
`;
